import React, { Component } from "react";
import { Grid, Row, Col, Table, FormGroup, Modal } from "react-bootstrap";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import Card from "components/Card/Card.jsx";
import { WEB_URL } from "variables/Variables.jsx";
import Datetime from "react-datetime";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import moment from "moment";
import { ExportToCsv } from 'export-to-csv';
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

class TrackableLinks extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      linksList : null,
      dateStart: moment().subtract(1, 'months'),
      dateEnd: moment(),
      runningSearch : false,
      runningDeleteLink : false,
      runningDeleteAllLinks : false,
      linkFields : [],
      showModal : false,
      editingLink : null
    }
  }

  componentDidMount () {
    this.fetchLinks();
  }

  setDateStart(d){
    this.setState({dateStart : d});
  }

  setDateEnd(d){
    this.setState({dateEnd : d});
  }  

  fetchLinks(){
    this.setState({runningSearch : true});

    fetch("https://"+WEB_URL+"/account/api/trackable-link",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&detail=true',
      body: JSON.stringify({token : this.props.authDetail.token, checksum : this.props.authDetail.checksum, detail : true, publication : this.props.match.params.publication, action : 'fetch'})
    }).then(res => res.json())
      .then(
        (response) => {
          if(response.Error == "Authentication Failed"){
            this.props.setLoggedIn(false);    
            return;
          }

          var dl = [];
          for(var p=0;p<response.links.length;p++){
              dl.push(response.links[p]);
          }
          this.setState({linksList : dl})
          this.setState({runningSearch : false});
        },
        (error) => {
          debugger;
          this.setState({runningSearch : false});
        }
      )
  }

  csvExport(){
    const options = { 
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true, 
      showTitle: true,
      title: 'Links for ' + this.props.match.params.publication,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(this.state.linksList);
  }

  deleteAllTrackableLinks(){
    
  }

  viewHeatMap(props,e){
    this.props.history.push('/home/heatmap/'+props.linkAlias+'/'+props.identifier);
  }
  
  viewAnalytics(props,e){
    this.props.history.push('/home/analytics/'+props.linkAlias+'/'+props.identifier);
  }

  deleteTrackableLink(link){
    if(window.confirm('Are you sure you want to delete this entry?')){
      this.setState({runningDeleteLink : link});

      fetch("https://"+WEB_URL+"/account/api/trackable-link",{
        'method' : 'POST',
        'headers' : { 'Content-Type' : 'application/json'},
        //'body' : 'token='+this.props.authDetail.token+'&checksum='+this.props.authDetail.checksum+'&identifier='+publication[0]
        'body' : JSON.stringify({'token':this.props.authDetail.token,'checksum':this.props.authDetail.checksum,'action':'delete','identifier':link.identifier,'publication':this.props.match.params.publication})
      }).then(res => res.json())
        .then(
          (response) => {
            if(response.result == 'SUCCESS'){
              this.props.triggerNotification('success','tc',response.message);
              this.fetchLinks();
              this.setState({runningDeleteLink : false});
            }else{
              this.props.triggerNotification('error','tc',response.message);  
              this.fetchLinks();
              this.setState({runningDeleteLink : false});
            }
          },
          (error) => {
            this.props.triggerNotification('error','tc','Error deleting the entry. Please try again in a little while.');
            this.fetchLinks();
            this.setState({runningDeleteLink : false});
          }
        )
    }
  }

  getCloudLink(publication){
    if(this.props.authDetail.detail.cloudId && this.props.authDetail.detail.cloudId != this.props.authDetail.user){
      return "https://"+this.props.authDetail.detail.cloudId+".flowpaper.com/"+publication+"/";
    }else{
      return "https://online.flowpaper.com/"+this.props.authDetail.user+"/"+publication+"/";
    }
  }

  goBack(){
    this.props.history.push('/home/cloud/'); 
  }

  editTrackableLinkModal(link){
    this.setState({ editingLink : link, showModal: true });
  }

  copyTrackableLink(link){
    navigator.clipboard.writeText('https://link.flowpaper.com/'+link.identifier+'/');
    document.getElementById('copyLinkTextLabel').innerHTML = 'Link Copied!';

    setTimeout(function(){
        document.getElementById('copyLinkTextLabel').innerHTML = 'Copy Link';
    }, 3000);
  }

  handleModalClose(){
    this.setState({ showModal: false });
  }

  handleUpdateTrackableLink(){
    this.setState({runningSavingTrackableLink : true});

    fetch("https://"+WEB_URL+"/account/api/trackable-link",{
            'method' : 'POST',
            'headers' : { 'Content-Type' : 'application/json'},
            'body' : JSON.stringify({   'token'                 : this.props.authDetail.token,
                                        'checksum'              : this.props.authDetail.checksum,
                                        'publication'           : this.props.match.params.publication,
                                        'identifier'            : this.state.editingLink.identifier,
                                        'action'                :'update',
                                        'label'                 : this.state.editingLink.label,
                                        'disableByDate'         : this.state.editingLink.disable_by && this.state.editingLink.disable_by.length > 0?new Date(this.state.editingLink.disable_by).toISOString():'',
                                        'emailWhenOpened'       : this.state.editingLink.email_when_opened,
                                        'emailWhenDownloaded'   : this.state.editingLink.email_when_downloaded,
                                        'emailIfNotOpenedBy'    : this.state.editingLink.email_ifnot_opened_by && this.state.editingLink.email_ifnot_opened_by.length > 0?new Date(this.state.editingLink.email_ifnot_opened_by).toISOString():''})
          }).then(res => res.json())
            .then(
              (response) => {
                    if(response.result == 'SUCCESS'){
                        this.fetchLinks();
                        this.setState({ showModal: false });
                    }

                    this.setState({runningSavingTrackableLink : false});
                },
                (error) => {
                    this.props.triggerNotification('error','tc','Error updating user details. Please try again in a little while.');
                    this.setState({runningUpdateProfileOperation : false});
                }
              )

  }

  handleUserInput (e) {
    if(e.target.name == 'NewLabel'){
      this.setState({editingLink : {...this.state.editingLink, label : e.target.value}});
    }

    if(e.target.name == 'chkDisableOn'){
      if(e.target.checked){
        this.setState({editingLink : {...this.state.editingLink, disable_by : new Date().toISOString()}});
      }else{
        this.setState({editingLink : {...this.state.editingLink, disable_by : null}});
      }
    }

    if(e.target.name == 'chkIfNotOpenedBy'){
        if(e.target.checked){
            this.setState({editingLink : {...this.state.editingLink, email_ifnot_opened_by : new Date().toISOString()}});
        }else{
            this.setState({editingLink : {...this.state.editingLink, email_ifnot_opened_by : null}});
        }
    }

    if(e.target.name == 'chkWhenOpened'){
        if(e.target.checked){
            this.setState({editingLink : {...this.state.editingLink, email_when_opened : true}});
        }else{
            this.setState({editingLink : {...this.state.editingLink, email_when_opened : false}});
        }
    }

    if(e.target.name == 'chkWhenDownloaded'){
        if(e.target.checked){
            this.setState({editingLink : {...this.state.editingLink, email_when_downloaded : true}});
        }else{
            this.setState({editingLink : {...this.state.editingLink, email_when_downloaded : false}});
        }
    }

    if(e.target.name == 'chkIfNotOpenedBy'){
        if(e.target.checked){
            this.setState({editingLink : {...this.state.editingLink, email_ifnot_opened_by : new Date().toISOString()}});
        }else{
            this.setState({editingLink : {...this.state.editingLink, email_ifnot_opened_by : null}});
        }
    }
  }

  handleSetEmailIfNotOpenedByDate(e){
    this.setState({editingLink : {...this.state.editingLink, email_ifnot_opened_by : e.toISOString()}})  
  }

  handleSetDisableByDate(e){
    this.setState({editingLink : {...this.state.editingLink, disable_by : e.toISOString()}});
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <ProgressButton bsStyle="default btn-wd btn btn-sm" fill type="submit" onClick={(e) => {this.goBack(e);}}><i class="pe-7s-back"></i> Go Back</ProgressButton>
              <h4 style={{'margin-top':20}}><b>Trackable Links for</b>:<br/><a target="_new" href={this.getCloudLink(this.props.match.params.publication)}>{this.getCloudLink(this.props.match.params.publication)}</a></h4>
            </Col>
          </Row>
          {this.state.linksList!=null ? 
          <Row>
            <Col md={12}>
            {this.state.linksList.length ? 
            <Card
                title=""
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Label</th>
                        <th>Link Created</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.linksList.map((link, index) => {
                        return (link.label?
                            <tr key={`${link.identifier}`}>
                            <td style={{'width':'50%'}}>
                                {link.label}
                            </td> 
                            <td style={{'width':'50%'}}>
                                {(link.created_at?new Date(link.created_at).toLocaleDateString():'')}
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                                <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.copyTrackableLink(link, e)}>
                                <i class="fa fa-copy"></i> <span id="copyLinkTextLabel">Copy Link</span>
                                </ProgressButton>
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                                <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.editTrackableLinkModal(link, e)}>
                                <i class="pe-7s-config"></i> Settings
                                </ProgressButton>
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                                <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.viewHeatMap(link, e)}>
                                <i class="pe-7s-look"></i> Heatmap
                                </ProgressButton>
                            </td>
                            <td style={{'width':'30px','padding':0,'padding-right':'5px'}}>
                                <ProgressButton runningAsyncOperation={false} bsStyle="default pull-right btn-xs" style={{marginRight:0,'min-height':'41px','min-width':'85px'}} fill type="submit" onClick={(e) => this.viewAnalytics(link, e)}>
                                <i class="pe-7s-graph1"></i> Stats
                                </ProgressButton>
                            </td>
                            <td style={{padding:0,paddingRight:10}}>
                              <ProgressButton style={{'min-height':'41px','min-width':'85px',marginLeft:0}} runningAsyncOperation={this.state.runningDeleteLink == link} bsStyle="danger pull-right btn-xs" fill type="submit" onClick={(e) => {this.deleteTrackableLink(link,e);}}>
                                Delete Entry
                              </ProgressButton>
                            </td>
                            </tr>
                        :'');
                    })}
                    </tbody>
                  </Table>
                }
              />:<Card
              title=""
              category=""
              ctTableFullWidth
              ctTableResponsive
              content={
                <div style={{margin:20}}>No available trackable links for this publication</div>
              }/>}
            </Col>
          </Row>
          :<div className="spinner-grow text-primary" role="status">
          <span className="sr-only">Loading...</span>
          </div>}
        </Grid>

        <Modal dialogClassName="modal-500w" show={this.state.showModal} onHide={(e) => {this.handleModalClose(e);}}>
            <Modal.Body>
            <Card
                  title="Edit Trackable Link"
                  plain="true"
                  content={
                  <form>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="control-label">Label</label>
                                <input name="NewLabel" placeholder="Label" type="text" class="form-control" value={this.state.editingLink?this.state.editingLink.label:''} onChange={(e) => {this.handleUserInput(e);}}></input>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col-md-12" style={{marginBottom:-17}}>
                            <label class="control-label" style={{marginTop:11,fontWeight:'bold'}}>Expiration Settings</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            <Checkbox name="chkDisableOn" onClick={(e) => {this.handleUserInput(e);}} style={{marginTop:12}} number="1" isChecked={this.state.editingLink && this.state.editingLink.disable_by && this.state.editingLink.disable_by.length > 0?true:false}/>
                        </div>
                        <div class="col-md-4">
                            <label class="control-label" style={{marginTop:11}}>Disable On</label>
                        </div>
                        <div class="col-md-4">
                        <FormGroup>
                            <Datetime
                            timeFormat={false}
                            name="dtDisableBy"
                            onChange={(d) => this.handleSetDisableByDate(d)}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "Disable Date" }}
                            value={this.state.editingLink && this.state.editingLink.disable_by?new Date(this.state.editingLink.disable_by).toLocaleDateString():''}
                            />
                        </FormGroup>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12" style={{marginBottom:-17}}>
                            <label class="control-label" style={{marginTop:11,fontWeight:'bold'}}>Email Me</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            <Checkbox name="chkWhenOpened" onClick={(e) => {this.handleUserInput(e);}} style={{marginTop:12}} number="2" isChecked={this.state.editingLink?this.state.editingLink.email_when_opened:false}/>
                        </div>
                        <div class="col-md-4">
                            <label class="control-label" style={{marginTop:11}}>When opened</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            <Checkbox name="chkWhenDownloaded" onClick={(e) => {this.handleUserInput(e);}} style={{marginTop:12}} number="3" isChecked={this.state.editingLink?this.state.editingLink.email_when_downloaded:false}/>
                        </div>
                        <div class="col-md-4">
                            <label class="control-label" style={{marginTop:11}}>When Downloaded</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1">
                            <Checkbox name="chkIfNotOpenedBy" onClick={(e) => {this.handleUserInput(e);}} style={{marginTop:12}} number="4" isChecked={this.state.editingLink && this.state.editingLink.email_ifnot_opened_by && this.state.editingLink.email_ifnot_opened_by.length > 0?true:false}/>
                        </div>
                        <div class="col-md-4">
                            <label class="control-label" style={{marginTop:11}}>If not opened by</label>
                        </div>
                        <div class="col-md-4">
                        <FormGroup>
                            <Datetime
                            timeFormat={false}
                            name="dtEmailIfNotOpenedBy"
                            onChange={(d) => this.handleSetEmailIfNotOpenedByDate(d)}
                            dateFormat="DD/MM/YYYY"
                            inputProps={{ placeholder: "Date if not opened" }}
                            value={this.state.editingLink && this.state.editingLink.email_ifnot_opened_by?new Date(this.state.editingLink.email_ifnot_opened_by).toLocaleDateString():''}
                            />
                        </FormGroup>
                        </div>
                    </div>
                </form>}
            />
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={(e) => {this.handleModalClose(e);}}>
                Cancel
            </Button>
            <ProgressButton runningAsyncOperation={this.state.runningSavingTrackableLink} bsStyle="info" fill type="submit" onClick={(e) => {this.handleUpdateTrackableLink(e);}}>
                Save Changes
            </ProgressButton>
            </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrackableLinks;
